import React, { useState } from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PaymentsIcon from '@mui/icons-material/Payments';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import EventIcon from '@mui/icons-material/Event';
import ApartmentIcon from '@mui/icons-material/Apartment';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CampaignIcon from '@mui/icons-material/Campaign';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AppShell from './AppShell';
import AdminContent from './AdminContent';

// Menu indexes must match the cases in AdminContent.jsx.
const MENU = [
  { key: 0, label: 'Şirket Ekle / Sil', icon: <BusinessIcon /> },
  { key: 1, label: 'Firma Takibi',      icon: <AssignmentTurnedInIcon /> },
  { key: 8, label: 'Aday Firma Takibi', icon: <PendingActionsIcon /> },
  { key: 2, label: 'Proje Takibi',      icon: <AccountTreeIcon /> },
  { key: 3, label: 'Firma Ödemeleri',   icon: <PaymentsIcon /> },
  { key: 4, label: 'Hatırlatıcılar',    icon: <NotificationsActiveIcon /> },
  { key: 9, label: 'Duyurular',         icon: <CampaignIcon /> },
  { key: 5, label: 'Bot Yönetimi',      icon: <SmartToyIcon /> },
  { key: 6, label: 'Resmi Tatiller',    icon: <EventIcon /> },
  { key: 10, label: 'TGB Takip',        icon: <ApartmentIcon /> },
  { key: 7, label: 'Sistem',            icon: <SettingsIcon /> },
];

function AdminPage() {
  const [selectedContent, setSelectedContent] = useState(0);

  const menuItems = MENU.map((m) => ({
    ...m,
    active: selectedContent === m.key,
    onClick: () => setSelectedContent(m.key),
  }));

  const title = MENU.find((m) => m.key === selectedContent)?.label || 'Yönetici Paneli';

  return (
    <AppShell title={title} brand="Yönetici" menuItems={menuItems}>
      <AdminContent content={selectedContent} />
    </AppShell>
  );
}

export default AdminPage;
